export default __webpack_public_path__ + "static/media/avatar_4_1.1fe1f9a0.png";